<nav class="letter-nav">
  <a
    *ngFor="let item of items"
    class="letter-item"
    [ngClass]="'accent-' + item.color"
    [routerLink]="item.path"
    routerLinkActive="active"
  >
    <span class="letter-badge">{{ item.letter }}</span>
    <span class="letter-label">{{ item.label }}</span>
  </a>
</nav>
